import React, { useContext, useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import LanguageContext from '../../contexts/LanguageContext';
import { getTranslation } from '../../services/languageService';
import { getProductsByCategory } from '../../services/productService';
import { getCategoryBySlug } from '../../services/categoryService';
import ProductCard from '../../components/products/ProductCard';
import '../Services.scss';

const ServiceDetail = () => {
  const { categoryKey } = useParams();
  const { language } = useContext(LanguageContext);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const category = getCategoryBySlug(categoryKey, language);
  const resolvedKey = category?.key || categoryKey;

  useEffect(() => {
    const loadProducts = () => {
      setLoading(true);
      const categoryProducts = getProductsByCategory(resolvedKey, language);
      setProducts(categoryProducts);
      setLoading(false);
    };

    loadProducts();
  }, [resolvedKey, language]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
  };

  const camelKey = resolvedKey.replace(/-([a-z])/g, (_, c) => c.toUpperCase());
  const titleKey = `services.${camelKey}.title`;

  return (
    <motion.div
      className="services-detail"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <section className="section">
        <div className="container">
          <motion.div className="back-link" variants={itemVariants}>
            <Link to="/services">&larr; {getTranslation('services.title', language)}</Link>
          </motion.div>

          <motion.h1 className="page-title text-center" variants={itemVariants}>
            {getTranslation(titleKey, language)}
          </motion.h1>

          {products.length > 0 && (
            <motion.div className="products-section" variants={itemVariants}>
              <h2 className="section-title">
                {getTranslation('services.ourProducts', language) || 'Our Products & Solutions'}
              </h2>
              <div className="products-grid">
                {products.map((product) => (
                  <ProductCard
                    key={product.id}
                    product={product}
                    context="category"
                    showImage={true}
                    showDescription={true}
                    showPrice={true}
                    showTags={false}
                    showFeatures={true}
                  />
                ))}
              </div>
            </motion.div>
          )}

          {!loading && products.length === 0 && (
            <motion.div className="products-section" variants={itemVariants}>
              <h2 className="section-title">
                {getTranslation('services.ourProducts', language) || 'Our Products & Solutions'}
              </h2>
              <div className="no-products">
                <p>{getTranslation('services.noProductsAvailable', language) || 'No products available in this category yet.'}</p>
              </div>
            </motion.div>
          )}

        </div>
      </section>
    </motion.div>
  );
};

export default ServiceDetail;
